<template>
  <div class="kw_cell_group">
    <div class="i-class i-cell-group">
        <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'kw_cell_group',
  props: {
    msg: String
  },
  data() {
    return {
      
    };
  },
  created() {
    
  },
  mounted() {
    
  },
  watch:{
  },
  computed:{
  },
  components: {
  },
  methods: {
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
